import {useEffect, useRef} from 'react';
import {useModalData} from '@Components/modal/hooks/useModalData';
import {MODALS_IDS} from '@Components/modal-container';
import {useAiChatActions} from '@/ai-chat/providers/ai-chat.context';
import {LoadingStates} from '@Utils/loading.util';
import {invalidateModalSession} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';

export const useResetAiActionLoadingStatesOnModalClose = (chatId: string, hashedId: string): void => {
  const actions = useAiChatActions();
  const modal = useModalData(MODALS_IDS.AI_ACTION_LOADING_MODAL);
  const wasOpenRef = useRef<boolean>(modal?.isOpen);

  useEffect(() => {
    const isCurrentlyOpen = modal?.isOpen;

    if (wasOpenRef.current && !isCurrentlyOpen) {
      invalidateModalSession();
      actions.updateLoadingStatesForImageActions(chatId, hashedId, {
        downloadLoadingState: LoadingStates.NOT_LOADED,
        publishingLoadingState: LoadingStates.NOT_LOADED,
        shareLoadingState: LoadingStates.NOT_LOADED,
        saveToMyDesignsLoadingState: LoadingStates.NOT_LOADED,
        loadingPublishingOption: null,
        makeTextEditableLoadingState: LoadingStates.NOT_LOADED,
        makeTextEditableLayerDecompositionModel: null,
      });
    }

    wasOpenRef.current = isCurrentlyOpen;
  }, [modal?.isOpen]);
};
